import React, { useEffect, useState } from 'react'
import Container from '../../../../constants/Container'
import { formatMoney_2 } from '../../../../helpers/DateFormat'
interface VoucherRptProps {
    onVoucherReport: any
}

interface Voucher {
    debitamt?: number;
    creditamt?: number;
}


interface TotalAmount {
    totalDebit: number;
    totalCredit: number;
}
const VoucherRptListView: React.FC<VoucherRptProps> = ({ onVoucherReport }) => {
    const [totalAmt, setOnTotalAmt] = useState<TotalAmount>({ totalDebit: 0, totalCredit: 0 });
    useEffect(() => {
        const results = onVoucherReport?.results || [];
        const totalDebitAmount = results.reduce((total:number, voucher:any) => total + (voucher.debitamt || 0), 0);
        const totalCreditAmount = results.reduce((total:number, voucher:any) => total + (voucher.creditamt || 0), 0);

        setOnTotalAmt({ totalDebit: totalDebitAmount, totalCredit: totalCreditAmount });
    }, [onVoucherReport]);

    return (
        <Container padding>
            <div className="relative overflow-x-auto">
                <table className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                    <thead className="text-[12px] text-gray-700 bg-slate-100 capitalize border-b dark:bg-sky-950 dark:text-slate-400 font-public-sans">
                        <tr>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-gray-200 dark:border-sky-800 w-10">
                                S.N.
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-gray-200 dark:border-sky-800 w-10">
                                GLID
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-gray-200 dark:border-sky-800">
                               Particulars
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-gray-200 dark:border-sky-800">
                                Debit Amount
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-gray-200 dark:border-sky-800">
                                Credit Amount
                            </th>
                        </tr>
                    </thead>
                    <tbody className='text-slate-800'>
                        {Array.isArray(onVoucherReport?.results) &&
                            onVoucherReport?.results?.map((voucher: any, index: number) =>
                            (
                                <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                                    <td align='center' className="px-2 border font-medium py-0.5 dark:border-sky-800 capitalize">
                                        {index + 1}.
                                    </td>
                                    <td align='center' className="px-2 border font-medium py-0.5 dark:border-sky-800 capitalize">
                                        {`${voucher?.glid ? voucher?.glid : ""}${voucher?.subledgerid ? "." + voucher?.subledgerid : ""}`}
                                    </td>
                                    <td align='left' className="px-2 font-medium py-0.5 border dark:border-sky-800 capitalize text-[11px]">
                                        {voucher?.glname}
                                    </td>
                                    <td align='right' className="px-2 border py-0.5 dark:border-sky-800">
                                        {voucher?.debitamt ? formatMoney_2(voucher?.debitamt) : formatMoney_2(0)}
                                    </td>
                                    <td align='right' className="px-2 border py-0.5 dark:border-sky-800 ">
                                        {voucher?.creditamt ? formatMoney_2(voucher?.creditamt) : formatMoney_2(0)}
                                    </td>
                                </tr>
                            )
                            )
                        }
                        <tr className='font-public-sans text-black bg-slate200 text-[11px]'>
                            <td align='right' colSpan={3} className="px-2 font-semibold py-1 border dark:border-sky-800 uppercase">
                                Total
                            </td>
                            <td align='right' className="px-2 font-semibold py-1 border dark:border-sky-800 capitalize">
                                {formatMoney_2(totalAmt?.totalDebit ||0)}
                            </td>
                            <td align='right' className="px-2 font-semibold py-1 border dark:border-sky-800 capitalize">
                                {formatMoney_2(totalAmt?.totalCredit||0)}
                            </td>
                         
                        </tr>
                    </tbody>
                </table>
            </div>
        </Container>
    )
}

export default VoucherRptListView